import React from 'react';
import { Coins, MessageCircle, X } from 'lucide-react';
import BottomSheetModal from '../shared/BottomSheetModal';
import { WHATSAPP_NUMBER, whatsAppUrl } from '../../config/whatsapp';

interface PurchaseFitCoinsModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentBalance: number;
  onPurchase: (amount: number, price: number) => void;
}

/* COMMENTED OUT - ORIGINAL MULTI-PACKAGE VERSION
interface CoinPackage {
  coins: number;
  price: number;
  popular?: boolean;
  bonus?: number;
}

const COIN_PACKAGES: CoinPackage[] = [
  { coins: 100, price: 2500, popular: true }, // Monthly - Basic
  { coins: 200, price: 5000, bonus: 50 }, // Monthly - Standard (+50 bonus)
  { coins: 800, price: 10000, bonus: 200 }, // Monthly - Premium (+200 bonus)
];
*/

const PurchaseFitCoinsModal: React.FC<PurchaseFitCoinsModalProps> = ({
  isOpen,
  onClose,
  currentBalance: _currentBalance,
  onPurchase: _onPurchase,
}) => {
  // COMMENTED OUT - Original purchase logic
  // const [selectedPackage, setSelectedPackage] = useState<CoinPackage | null>(null);
  // const [isProcessing, setIsProcessing] = useState(false);

  // const handlePurchase = async () => {
  //   if (!selectedPackage) return;
  //   setIsProcessing(true);
  //   try {
  //     await new Promise(resolve => setTimeout(resolve, 1500));
  //     const totalCoins = selectedPackage.coins + (selectedPackage.bonus || 0);
  //     onPurchase(totalCoins, selectedPackage.price);
  //     onClose();
  //   } catch (error) {
  //     console.error('Purchase failed:', error);
  //   } finally {
  //     setIsProcessing(false);
  //   }
  // };

  // ACTIVE - Simplified WhatsApp contact
  const handleContactSales = () => {
    const message = `Hi! I'm interested in purchasing FitCoins for virtual try-ons. I'd like to discuss the ₦2,500/month plan for 100 coins.`;
    window.open(whatsAppUrl(message, WHATSAPP_NUMBER), '_blank');
  };

  /* COMMENTED OUT - ORIGINAL MULTI-PACKAGE DESIGN
  return (
    <>
      {/* Desktop Modal *\/}
      <div className={`hidden md:${isOpen ? 'block' : 'hidden'} fixed inset-0 z-[60] bg-black/50 backdrop-blur-md`}>
        <div className="flex items-center justify-center min-h-full p-4">
          <div className="relative bg-white rounded-3xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-hidden">
            {/* Close Button *\/}
            <button
              type="button"
              onClick={onClose}
              className="absolute top-6 right-6 p-2 hover:bg-gray-100 rounded-full transition-all z-10"
            >
              <X size={18} className="text-gray-600" />
            </button>
            
            {/* Content *\/}
            <div className="overflow-y-auto max-h-[90vh] px-8 py-8">
              <div className="space-y-5 pb-4">
                {/* Hero Section *\/}
                <div className="text-center pt-2 pb-3">
                  <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-2xl mb-3 shadow-lg">
                    <Coins size={28} className="text-white" />
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-2">Explore beautiful designs by African Creators</h2>
                  <p className="text-sm text-gray-600 max-w-xs mx-auto leading-relaxed">
                    Discover inspiring African fashion, explore creative styles, and find pieces that make you feel truly confident and seen 
                  </p>
                </div>

                {/* Coin Packages *\/}
                <div>
                  <h3 className="text-sm font-semibold text-gray-900 mb-3 text-center">Choose your plan</h3>
                  <div className="grid grid-cols-3 gap-2.5">
                    {COIN_PACKAGES.map((pkg, index) => {
                      const totalCoins = pkg.coins + (pkg.bonus || 0);
                      const isSelected = selectedPackage?.coins === pkg.coins;
                      
                      return (
                        <button
                          key={index}
                          onClick={() => setSelectedPackage(pkg)}
                          className={`relative p-3 rounded-xl border-2 transition-all ${
                            isSelected
                              ? 'border-amber-500 bg-gradient-to-br from-amber-50 to-yellow-50 shadow-lg scale-[0.98]'
                              : 'border-gray-200 bg-white hover:border-amber-200 hover:shadow-sm'
                          }`}
                        >
                          {pkg.popular && (
                            <div className="absolute -top-2 left-1/2 -translate-x-1/2 px-2 py-0.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-[10px] font-bold rounded-full shadow-md flex items-center gap-0.5">
                              Popular
                            </div>
                          )}
                          {pkg.bonus && (
                            <div className="absolute -top-2 left-1/2 -translate-x-1/2 px-2 py-0.5 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-[10px] font-bold rounded-full shadow-sm flex items-center gap-0.5">
                              <Zap size={9} />
                              +{pkg.bonus}
                            </div>
                          )}
                          {isSelected && (
                            <div className="absolute top-2 right-2 w-4 h-4 bg-amber-500 rounded-full flex items-center justify-center shadow-sm">
                              <Check size={12} className="text-white" strokeWidth={3} />
                            </div>
                          )}
                          <div className="text-center mt-1">
                            <div className="flex items-center justify-center gap-1 mb-0.5">
                              <Coins size={18} className="text-amber-600" />
                              <span className="text-xl font-bold text-gray-900">{totalCoins}</span>
                            </div>
                            <p className="text-[10px] text-gray-500 font-medium mb-1.5">coins</p>
                            <div className="pt-1.5 border-t border-gray-200">
                              <p className="text-base font-bold text-gray-900">₦{pkg.price.toLocaleString()}</p>
                              <p className="text-[10px] text-gray-500">/month</p>
                            </div>
                          </div>
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* Purchase Button *\/}
                <button
                  onClick={handlePurchase}
                  disabled={!selectedPackage || isProcessing}
                  className="w-full py-3.5 bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 disabled:from-gray-300 disabled:to-gray-400 disabled:cursor-not-allowed text-white font-bold rounded-xl transition-all shadow-lg hover:shadow-xl disabled:shadow-none flex items-center justify-center gap-2 text-sm"
                >
                  {isProcessing ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      Processing...
                    </>
                  ) : selectedPackage ? (
                    <>
                      Get {selectedPackage.coins + (selectedPackage.bonus || 0)} coins for ₦{selectedPackage.price.toLocaleString()}/month
                    </>
                  ) : (
                    'Select a plan to continue'
                  )}
                </button>

                {/* Terms and Cancel Info *\/}
                <div className="text-center space-y-2 pt-2">
                  <p className="text-xs text-gray-500">
                    Cancel anytime • No commitments
                  </p>
                  <p className="text-xs text-gray-400">
                    By continuing, you agree to our{' '}
                    <a 
                      href="/terms" 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-amber-600 hover:text-amber-700 underline font-medium"
                    >
                      Terms & Conditions
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Bottom Sheet *\/}
      <div className="md:hidden">
        <BottomSheetModal
          isOpen={isOpen}
          onClose={onClose}
          title="Get Fit Coins"
          maxHeight="max-h-[80vh]"
        >
          <div className="space-y-5 pb-4">
            {/* Hero Section *\/}
            <div className="text-center pt-2 pb-3">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-2xl mb-3 shadow-lg">
                <Coins size={28} className="text-white" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Explore beautiful designs by African Creators</h2>
              <p className="text-sm text-gray-600 max-w-xs mx-auto leading-relaxed">
                Discover inspiring African fashion, explore creative styles, and find pieces that make you feel truly confident and seen 
              </p>
            </div>

            {/* Coin Packages *\/}
            <div>
              <h3 className="text-sm font-semibold text-gray-900 mb-3 text-center">Choose your plan</h3>
              <div className="grid grid-cols-3 gap-2.5">
                {COIN_PACKAGES.map((pkg, index) => {
                  const totalCoins = pkg.coins + (pkg.bonus || 0);
                  const isSelected = selectedPackage?.coins === pkg.coins;
                  
                  return (
                    <button
                      key={index}
                      onClick={() => setSelectedPackage(pkg)}
                      className={`relative p-3 rounded-xl border-2 transition-all ${
                        isSelected
                          ? 'border-amber-500 bg-gradient-to-br from-amber-50 to-yellow-50 shadow-lg scale-[0.98]'
                          : 'border-gray-200 bg-white hover:border-amber-200 hover:shadow-sm'
                      }`}
                    >
                      {pkg.popular && (
                        <div className="absolute -top-2 left-1/2 -translate-x-1/2 px-2 py-0.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-[10px] font-bold rounded-full shadow-md flex items-center gap-0.5">
                          Popular
                        </div>
                      )}
                      {pkg.bonus && (
                        <div className="absolute -top-2 left-1/2 -translate-x-1/2 px-2 py-0.5 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-[10px] font-bold rounded-full shadow-sm flex items-center gap-0.5">
                          <Zap size={9} />
                          +{pkg.bonus}
                        </div>
                      )}
                      {isSelected && (
                        <div className="absolute top-2 right-2 w-4 h-4 bg-amber-500 rounded-full flex items-center justify-center shadow-sm">
                          <Check size={12} className="text-white" strokeWidth={3} />
                        </div>
                      )}
                      <div className="text-center mt-1">
                        <div className="flex items-center justify-center gap-1 mb-0.5">
                          <Coins size={18} className="text-amber-600" />
                          <span className="text-xl font-bold text-gray-900">{totalCoins}</span>
                        </div>
                        <p className="text-[10px] text-gray-500 font-medium mb-1.5">coins</p>
                        <div className="pt-1.5 border-t border-gray-200">
                          <p className="text-base font-bold text-gray-900">₦{pkg.price.toLocaleString()}</p>
                          <p className="text-[10px] text-gray-500">/month</p>
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Purchase Button *\/}
            <button
              onClick={handlePurchase}
              disabled={!selectedPackage || isProcessing}
              className="w-full py-3.5 bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 disabled:from-gray-300 disabled:to-gray-400 disabled:cursor-not-allowed text-white font-bold rounded-xl transition-all shadow-lg hover:shadow-xl disabled:shadow-none flex items-center justify-center gap-2 text-sm"
            >
              {isProcessing ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Processing...
                </>
              ) : selectedPackage ? (
                <>
                  Get {selectedPackage.coins + (selectedPackage.bonus || 0)} coins for ₦{selectedPackage.price.toLocaleString()}/month
                </>
              ) : (
                'Select a plan to continue'
              )}
            </button>

            {/* Terms and Cancel Info *\/}
            <div className="text-center space-y-2 pt-2">
              <p className="text-xs text-gray-500">
                Cancel anytime • No commitments
              </p>
              <p className="text-xs text-gray-400">
                By continuing, you agree to our{' '}
                <a 
                  href="/terms" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-amber-600 hover:text-amber-700 underline font-medium"
                >
                  Terms & Conditions
                </a>
              </p>
            </div>
          </div>
        </BottomSheetModal>
      </div>
    </>
  );
  */

  // ACTIVE - SIMPLIFIED WHATSAPP CONTACT DESIGN
  return (
    <>
      {/* Desktop Modal */}
      <div className={`hidden md:${isOpen ? 'block' : 'hidden'} fixed inset-0 z-[60] bg-black/50 backdrop-blur-md`}>
        <div className="flex items-center justify-center min-h-full p-4">
          <div className="relative bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden">
            {/* Close Button */}
            <button
              type="button"
              onClick={onClose}
              className="absolute top-6 right-6 p-2 hover:bg-gray-100 rounded-full transition-all z-10"
            >
              <X size={18} className="text-gray-600" />
            </button>
            
            {/* Content */}
            <div className="px-8 py-8">
              <div className="space-y-6">
                {/* Hero Section */}
                <div className="text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-2xl mb-4 shadow-lg">
                    <Coins size={32} className="text-white" />
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-2">Get FitCoins</h2>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Unlock virtual try-ons and explore beautiful designs by African creators
                  </p>
                </div>

                {/* Single Package */}
                <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center">
                        <Coins size={20} className="text-amber-600" />
                      </div>
                      <div className="text-left">
                        <p className="text-lg font-extrabold text-gray-900 tracking-tight">
                          100&nbsp;FitCoins
                        </p>
                        <p className="text-xs font-medium text-amber-700">
                          Perfect for a start
                        </p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-xl font-bold text-gray-900">₦2,500</p>
                      <p className="text-xs text-gray-500">/month</p>
                    </div>
                  </div>
                </div>

                {/* Contact Sales Button */}
                <button
                  onClick={handleContactSales}
                  className="w-full py-4 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white font-bold rounded-xl transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                >
                  <MessageCircle size={20} />
                  Contact Sales on WhatsApp
                </button>

                {/* Info Text */}
                <p className="text-xs text-gray-500 text-center">
                  Chat with our team to complete your purchase
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Bottom Sheet */}
      <div className="md:hidden">
        <BottomSheetModal
          isOpen={isOpen}
          onClose={onClose}
          title="Get FitCoins"
          maxHeight="max-h-[75vh]"
        >
          <div className="space-y-6 pb-4">
            {/* Hero Section */}
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-2xl mb-4 shadow-lg">
                <Coins size={32} className="text-white" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Get FitCoins</h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                Unlock virtual try-ons and explore beautiful designs by African creators
              </p>
            </div>

            {/* Single Package */}
            <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center">
                    <Coins size={20} className="text-amber-600" />
                  </div>
                  <div className="text-left">
                    <p className="text-lg font-bold text-gray-900">100 Coins</p>
                    <p className="text-xs text-gray-500">
                     Perfect for a start
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xl font-bold text-gray-900">₦2,500</p>
                  <p className="text-xs text-gray-500">/month</p>
                </div>
              </div>
            </div>

            {/* Contact Sales Button */}
            <button
              onClick={handleContactSales}
              className="w-full py-4 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white font-bold rounded-xl transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
            >
              <MessageCircle size={20} />
              Contact Sales on WhatsApp
            </button>

            {/* Info Text */}
            <p className="text-xs text-gray-500 text-center">
              Chat with our team to complete your purchase
            </p>
          </div>
        </BottomSheetModal>
      </div>
    </>
  );
};

export default PurchaseFitCoinsModal;
